<div class="flex min-h-[calc(100vh-48px)] flex-col gap-5 bg-light-color px-6 py-6 font-base text-dark-color">
  <header class="flex flex-col gap-4 rounded-2xl bg-gradient-to-r from-[var(--primary-color)] via-[var(--primary-color-hover)] to-[var(--second-color)] px-6 py-6 text-light-color shadow-[0_14px_40px_var(--box-shadow-color)] md:flex-row md:items-start md:justify-between md:gap-6">
    <div class="flex flex-col gap-2">
      <p class="text-xs uppercase tracking-[0.12em] text-light-color/80">Licencas</p>
      <h1 class="text-2xl font-semibold leading-tight">Gerencie licencas e renovacoes</h1>
      <p class="max-w-3xl text-sm text-light-color/90">
        Acompanhe creditos, canais e status das licencas. Renove clientes e ajuste renovacao automatica.
      </p>
    </div>
    <div class="grid gap-3 text-sm sm:grid-cols-3">
      <div class="rounded-xl bg-white/10 px-4 py-3 shadow">
        <div class="flex items-start justify-between gap-3">
          <div>
            <p class="m-0 text-xs uppercase tracking-[0.12em] text-light-color/80">Creditos</p>
            <strong class="text-lg">{{ creditsUser || 0 }}</strong>
          </div>
          <button
            type="button"
            class="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-white/20 text-white transition hover:bg-white/30"
            (click)="abrirModalCreditos()"
            aria-label="Adicionar creditos">
            <mat-icon>add</mat-icon>
          </button>
        </div>
      </div>
      <div class="rounded-xl bg-white/10 px-4 py-3 shadow">
        <p class="m-0 text-xs uppercase tracking-[0.12em] text-light-color/80">Canais</p>
        <strong class="text-lg">Ativos: {{ canaisAtivos }}</strong>
        <p class="text-xs text-light-color/80">Inativos: {{ canaisInativos }}</p>
      </div>
      <div class="rounded-xl bg-white/10 px-4 py-3 shadow">
        <p class="m-0 text-xs uppercase tracking-[0.12em] text-light-color/80">Licencas</p>
        <strong class="text-lg">Ativos: {{ clientesAtivos }}</strong>
        <p class="text-xs text-light-color/80">Inativos: {{ clientesInativos }}</p>
      </div>
    </div>
  </header>

  <section class="flex flex-col gap-4 rounded-xl border border-border-color bg-white px-5 py-5 shadow-[0_12px_36px_var(--box-shadow-color)]">
    <div class="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
      <p class="text-sm text-dark-color/70">Filtre rapidamente por revendedor, status ou nome do cliente.</p>
      <div class="flex flex-wrap items-center gap-2">
        <select
          class="min-w-[200px] rounded-base border border-border-color bg-white px-3 py-2 text-sm text-dark-color"
          *ngIf="returnLevel() === 3">
          <option value="">Todos os revendedores</option>
          <option *ngFor="let revendedor of listRevendedores" [value]="revendedor">{{ revendedor }}</option>
        </select>
        <select
          class="min-w-[160px] rounded-base border border-border-color bg-white px-3 py-2 text-sm text-dark-color"
          [(ngModel)]="filterStatus">
          <option value="TODOS">Todos os status</option>
          <option value="ATIVO">Ativo</option>
          <option value="INATIVO">Inativo</option>
        </select>
        <label class="flex min-w-[220px] items-center gap-2 rounded-base border border-border-color bg-light-color px-3 py-2 text-sm text-dark-color">
          <mat-icon>search</mat-icon>
          <input
            type="search"
            placeholder="Pesquisar"
            class="w-full bg-transparent outline-none"
            [(ngModel)]="filterName" />
        </label>
      </div>
    </div>

    <ng-container *ngIf="clientsSelected">
      <div class="flex flex-col gap-2 sm:flex-row sm:justify-center">
        <button
          type="button"
          class="rounded-full bg-primary-color px-6 py-2 text-sm font-semibold text-white shadow transition hover:bg-primary-hover"
          (click)="sendPedidoRenewClients()">
          Renovar selecionados - PIX
        </button>
        <button
          type="button"
          class="rounded-full bg-gray-300 px-6 py-2 text-sm font-semibold text-gray-600"
          style="cursor: not-allowed;"
          disabled>
          Renovar selecionados - Creditos
        </button>
      </div>
    </ng-container>

    <div class="overflow-hidden rounded-xl border border-border-color">
      <table class="min-w-full divide-y divide-border-color text-sm">
        <thead class="bg-light-color/60">
          <tr>
            <th class="px-4 py-3 text-center font-semibold text-dark-color">#</th>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">Cliente</th>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">Email</th>
            <th class="px-4 py-3 text-center font-semibold text-dark-color">Nº Canais</th>
            <th class="px-4 py-3 text-center font-semibold text-dark-color">Status</th>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">Criacao</th>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">Vencimento</th>
            <th class="px-4 py-3 text-left font-semibold text-dark-color">Renovacao</th>
            <th class="px-4 py-3 text-center font-semibold text-dark-color" title="Ativa a renovacao automatica por creditos">Ren. Auto</th>
            <th class="px-4 py-3 text-right font-semibold text-dark-color">Acoes</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-border-color">
          <tr
            *ngFor="let client of listClients | clientFilterName: filterName | clientFilterStatus: filterStatus | paginate: { itemsPerPage: objectPage.itemsPerPage, currentPage: objectPage.currentPage }"
            class="transition hover:bg-light-color/60">
            <td class="px-4 py-3 text-center">
              <input
                type="checkbox"
                class="h-4 w-4 rounded border-border-color text-primary-color"
                (change)="onCheckBoxSelectedClient($event, client.idcliente, client.email, client.canais)" />
            </td>
            <td class="px-4 py-3 text-dark-color">{{ client.nome }}</td>
            <td class="px-4 py-3 text-dark-color">{{ client.email }}</td>
            <td class="px-4 py-3 text-center text-dark-color">{{ client.canais }}</td>
            <td class="px-4 py-3 text-center">
              <mat-icon [ngClass]="client.status === 'ATIVO' ? 'text-green-500' : 'text-red-500'">
                {{ client.status === 'ATIVO' ? 'check_circle' : 'cancel' }}
              </mat-icon>
            </td>
            <td class="px-4 py-3 text-dark-color">{{ formatData(client.createdAt) }}</td>
            <td class="px-4 py-3 text-dark-color">{{ formatData(client.vencimento) }}</td>
            <td class="px-4 py-3 text-dark-color">{{ formatData(client.ultAtivacao) }}</td>
            <td class="px-4 py-3 text-center">
              <button
                type="button"
                (click)="alterRen(client)"
                [attr.aria-pressed]="client.billingCreditsRecorrency"
                class="relative inline-flex h-7 w-14 items-center rounded-full transition focus:outline-none"
                [ngClass]="client.billingCreditsRecorrency ? 'bg-green-500' : 'bg-gray-300'">
                <span class="sr-only">Renovacao automatica por creditos</span>
                <span
                  class="inline-block h-6 w-6 transform rounded-full bg-white shadow transition"
                  [ngClass]="client.billingCreditsRecorrency ? 'translate-x-7' : 'translate-x-1'"></span>
              </button>
            </td>
            <td class="px-4 py-3 text-right">
              <div class="flex justify-end gap-2">
                <button
                  *ngIf="returnLevel() <= 2"
                  type="button"
                  class="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-border-color bg-white text-emerald-600 transition hover:border-primary-color"
                  title="Renovar Licenca do Cliente Utilizando Creditos"
                  (click)="abrirModalRenovarCliente(client)">
                  <mat-icon>currency_exchange</mat-icon>
                </button>
                <button
                  *ngIf="returnLevel() === 3"
                  type="button"
                  class="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-border-color bg-white text-emerald-600 transition hover:border-primary-color"
                  title="Renovar Licenca do Cliente"
                  (click)="abrirModalRenovarCliente(client)">
                  <mat-icon>{{ returnLevel() === 3 ? 'restart_alt' : 'paid' }}</mat-icon>
                </button>
                <button
                  *ngIf="returnLevel() <= 2"
                  type="button"
                  class="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-border-color bg-white text-emerald-600 transition hover:border-primary-color"
                  title="Renovar Licenca do Cliente"
                  (click)="renovarClientePix(client)">
                  <mat-icon>{{ returnLevel() === 3 ? 'restart_alt' : 'paid' }}</mat-icon>
                </button>
                <button
                  type="button"
                  class="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-border-color bg-white text-red-500 transition hover:border-red-500"
                  title="Inativar Licenca do Cliente"
                  (click)="sendPedidoBloquearCliente(client.idcliente)">
                  <mat-icon>lock</mat-icon>
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="listClients.length === 0">
            <td colspan="10" class="px-4 py-6 text-center text-dark-color/70">Nenhuma licenca encontrada.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="flex flex-col items-center justify-between gap-3 text-sm md:flex-row">
      <div class="flex items-center gap-2">
        <span>Registros por pagina:</span>
        <select
          class="rounded-base border border-border-color px-3 py-2 text-dark-color"
          (change)="alterItemsPerPage($event)">
          <option value="5">5</option>
          <option value="10">10</option>
          <option value="20">20</option>
        </select>
        <span>Pagina {{ objectPage.currentPage }} de {{ objectPage.totalPages || 1 }}</span>
      </div>
      <div class="flex items-center gap-2">
        <button
          type="button"
          class="flex h-9 w-9 items-center justify-center rounded-lg border border-border-color text-dark-color transition hover:border-primary-color hover:text-primary-color"
          [disabled]="isFirstPage()"
          (click)="previousPage()">
          <mat-icon>arrow_back_ios</mat-icon>
        </button>
        <span class="font-semibold">{{ objectPage.currentPage }}</span>
        <button
          type="button"
          class="flex h-9 w-9 items-center justify-center rounded-lg border border-border-color text-dark-color transition hover:border-primary-color hover:text-primary-color"
          [disabled]="isLastPage()"
          (click)="nextPage()">
          <mat-icon>arrow_forward_ios</mat-icon>
        </button>
      </div>
    </div>
  </section>
</div>

<ng-container *ngIf="activeModalCredits">
  <div class="fixed inset-0 z-40 flex items-start justify-center bg-black/50 px-4 pb-6 pt-12 sm:pt-16">
    <div class="w-full max-w-md max-h-[calc(100vh-64px)] overflow-y-auto rounded-xl bg-white p-5 shadow-2xl sm:p-6">
      <div class="flex items-start justify-between border-b border-border-color pb-3">
        <div>
          <p class="text-xs uppercase tracking-[0.12em] text-primary-color">Creditos</p>
          <h3 class="text-lg font-semibold text-dark-color">Adicionar creditos</h3>
        </div>
        <button type="button" class="text-dark-color/70 transition hover:text-dark-color" (click)="fecharModalCreditos()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <form class="mt-4 flex flex-col gap-4" [formGroup]="formCredits" (ngSubmit)="adicionarCreditos()">
        <label for="creditInput" class="flex flex-col gap-2 text-sm text-dark-color">
          <span class="font-semibold">Valor dos creditos</span>
          <input
            id="creditInput"
            type="number"
            min="1"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
            formControlName="creditos" />
        </label>
        <div class="flex justify-end">
          <button
            type="submit"
            class="inline-flex items-center gap-2 rounded-base bg-primary-color px-6 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover disabled:cursor-not-allowed disabled:bg-gray-400"
            [disabled]="isLoadingAddCredits">
            <span
              *ngIf="isLoadingAddCredits"
              class="h-4 w-4 animate-spin rounded-full border-2 border-white/60 border-t-white"></span>
            Adicionar
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="activeModalRenew">
  <div class="fixed inset-0 z-40 flex items-start justify-center bg-black/50 px-4 pb-6 pt-12 sm:pt-16" *ngIf="returnLevel() === 3">
    <div class="w-full max-w-md max-h-[calc(100vh-64px)] overflow-y-auto rounded-xl bg-white p-5 shadow-2xl sm:p-6">
      <div class="flex items-start justify-between border-b border-border-color pb-3">
        <h3 class="text-lg font-semibold text-dark-color">Renovar cliente ID: {{ formRenovarCliente.get('idcliente')?.value }}</h3>
        <button type="button" class="text-dark-color/70 transition hover:text-dark-color" (click)="fecharModalRenovarCliente()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <p class="mt-4 text-sm text-dark-color">Deseja renovar o cadastro do cliente?</p>
      <form class="mt-4 flex flex-col gap-3" [formGroup]="formRenovarCliente" (ngSubmit)="sendPedidoRenovarCliente()">
        <label class="flex flex-col gap-2 text-sm text-dark-color" for="renovacao-select">
          <span class="font-semibold">Periodo de renovacao</span>
          <select
            id="renovacao-select"
            class="rounded-base border border-border-color bg-white px-3 py-2 text-sm outline-none focus:border-primary-color"
            formControlName="renovacao">
            <option value="1" selected>5 Dias</option>
            <option value="2">15 Dias</option>
            <option value="3">Mensal</option>
            <option value="4">Trimestral</option>
            <option value="5">Anual</option>
            <option value="6">Indeterminado</option>
          </select>
        </label>
        <div class="flex justify-end">
          <button
            type="submit"
            class="rounded-base bg-primary-color px-6 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover">
            Renovar
          </button>
        </div>
      </form>
    </div>
  </div>

  <div class="fixed inset-0 z-40 flex items-start justify-center bg-black/50 px-4 pb-6 pt-12 sm:pt-16" *ngIf="returnLevel() <= 2">
    <div class="w-full max-w-md max-h-[calc(100vh-64px)] overflow-y-auto rounded-xl bg-white p-5 shadow-2xl sm:p-6">
      <div class="flex items-start justify-between border-b border-border-color pb-3">
        <h3 class="text-lg font-semibold text-dark-color">Renovar cliente ID: {{ formRenovarCliente.get('idcliente')?.value }}</h3>
        <button type="button" class="text-dark-color/70 transition hover:text-dark-color" (click)="fecharModalRenovarCliente()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <p class="mt-4 text-sm text-dark-color">Deseja renovar o cadastro do cliente?</p>
      <div class="mt-6 flex justify-end">
        <button
          type="button"
          class="rounded-base bg-primary-color px-6 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover"
          (click)="sendPedidoRenovarClienteCredito()">
          Confirmar
        </button>
      </div>
    </div>
  </div>
</ng-container>

<app-pix-modal></app-pix-modal>

<app-alert></app-alert>

<app-loading-modal></app-loading-modal>
